export class GPermiso {
    constructor(public tipo: string, public id_sistema: number, public id_perfil: number, public lt_permiso:  Permiso[], public nombre_usuario: string) {}
}

export class Permiso {
    constructor(public id_acceso: string, public seleccionar: boolean, public insertar: boolean, public eliminar: boolean, public actualizar: boolean) {}
}